import {arrayFlat} from './array.js';
import {isObject} from './object.js';

export function createElement(name){
	var parts = name.split('.');
	name = parts[0];
	var classes = parts.slice(1);
	
	var children = [].slice.call(arguments, 1);

	var el = document.createElement(name);

	if (children.length && isObject(children[0])){
		var attrs = children.shift();

		for (let k in attrs) if (attrs.hasOwnProperty(k)){
			el.setAttribute(k, attrs[k]);
		}
	}

	classes.forEach(function(c){
		el.classList.add(c);
	});

	children = arrayFlat(children);

	children.forEach(function(child){
		if (typeof child === 'string'){
			el.appendChild(document.createTextNode(child));
		}
		else if (!child){
			return;
		}
		else {
			el.appendChild(child);
		}
	});

	return el;
}

export function removeElement(element){
	element.parentNode.removeChild(element);
}

export function emptyElement(element){
	while (element.firstChild){
		element.removeChild(element.firstChild);
	}
}

export function prependElement(parent, element){
	if (parent.firstChild){
		parent.insertBefore(element, parent.firstChild);
	}
	else {
		parent.appendChild(element);
	}
}